(function () {
	var HEADER_SELECTOR = 'reviewsio-card-carousel .CarouselWidget__header';
	var BUTTON_CLASS = 'reviews-trust-info-button';
	var HEADER_ACTIVE_CLASS = 'reviews-trust-info-header--active';

	var TRIGGER_ICON_SVG = `
		<svg aria-hidden="true" focusable="false" role="presentation" class="reviews-trust-info-button__icon" viewBox="0 0 416.979 416.979">
			<g>
				<path d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85
					c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M237.6,340.786
					c0,3.217-2.607,5.822-5.822,5.822h-46.576c-3.215,0-5.822-2.605-5.822-5.822V167.885c0-3.217,2.607-5.822,5.822-5.822h46.576
					c3.215,0,5.822,2.604,5.822,5.822V340.786z M208.49,137.901c-18.618,0-33.766-15.146-33.766-33.765
					c0-18.617,15.147-33.766,33.766-33.766c18.619,0,33.766,15.148,33.766,33.766C242.256,122.755,227.107,137.901,208.49,137.901z"/>
			</g>
		</svg>
	`;

	var trustInfoModal = null;

	function getTrustInfoModal() {
		if (!trustInfoModal && window.theme && window.theme.Modals) {
			trustInfoModal = new window.theme.Modals('ReviewsTrustInfoModal', 'reviews-trust-info', {
				bodyOpenClass: ['modal-open', 'reviews-trust-info-modal-open'],
			});
		}
		return trustInfoModal;
	}

	function handleButtonClick(evt) {
		var modal = getTrustInfoModal();
		if (modal) modal.open(evt);
	}

	function createIcon() {
		var wrapper = document.createElement('span');
		wrapper.innerHTML = TRIGGER_ICON_SVG;
		return wrapper.firstElementChild;
	}

	function addButtonToHeader(header) {
		if (header.querySelector('.' + BUTTON_CLASS)) return;

		var button = document.createElement('button');
		button.type = 'button';
		button.className = BUTTON_CLASS;
		button.setAttribute('aria-haspopup', 'dialog');
		button.setAttribute('aria-controls', 'ReviewsTrustInfoModal');
		button.appendChild(createIcon());

		var label = document.createElement('span');
		label.textContent = window.theme.strings.reviewsTrustInfoLabel;
		button.appendChild(label);

		button.addEventListener('click', handleButtonClick);

		header.appendChild(button);
		header.classList.add(HEADER_ACTIVE_CLASS);
	}

	function scan(root) {
		if (root.matches && root.matches(HEADER_SELECTOR)) {
			addButtonToHeader(root);
		}
		if (root.querySelectorAll) {
			var headers = root.querySelectorAll(HEADER_SELECTOR);
			for (var i = 0; i < headers.length; i++) {
				addButtonToHeader(headers[i]);
			}
		}
	}

	function handleMutations(mutations) {
		for (var i = 0; i < mutations.length; i++) {
			var addedNodes = mutations[i].addedNodes;
			for (var j = 0; j < addedNodes.length; j++) {
				if (addedNodes[j].nodeType === 1) scan(addedNodes[j]);
			}
		}
	}

	function init() {
		if (!window.theme || !window.theme.settings || !window.theme.settings.reviewsTrustInfoEnable) return;

		scan(document);

		var observer = new MutationObserver(handleMutations);
		observer.observe(document.body, { childList: true, subtree: true });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
